module.exports = __webpack_public_path__ + "static/group-meeting-72abf02c1222b4fe641666e1274e50fc.webp";